var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H10.381L15.9962 30.0552C16.1878 31.0199 16.7126 31.8864 17.4787 32.5031C18.2448 33.1198 19.2034 33.4474 20.1867 33.4286H40.5524C41.5357 33.4474 42.4943 33.1198 43.2604 32.5031C44.0265 31.8864 44.5513 31.0199 44.7429 30.0552L48.0952 12.4762H12.4762M20.8571 43.9048C20.8571 45.0619 19.9191 46 18.7619 46C17.6047 46 16.6667 45.0619 16.6667 43.9048C16.6667 42.7476 17.6047 41.8095 18.7619 41.8095C19.9191 41.8095 20.8571 42.7476 20.8571 43.9048ZM43.9048 43.9048C43.9048 45.0619 42.9667 46 41.8095 46C40.6524 46 39.7143 45.0619 39.7143 43.9048C39.7143 42.7476 40.6524 41.8095 41.8095 41.8095C42.9667 41.8095 43.9048 42.7476 43.9048 43.9048Z",
    stroke: "#414042",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.b8dc1d59ada59c1230ce4aa3bea0c70b.svg";
export { ForwardRef as ReactComponent };